import {
    useMutation,
    useQuery,
} from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Delete, Get, Post, Put } from "../api";
import API_CONSTANTS from "../constants/api";
import { prepareData } from "../helpers/apiHelper";
import { MILISECONDS } from "../constants";
import { appendQueryParams } from "../helpers/queryHelper";;

export const useUsers = (params) => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["users", params],
        queryFn: async () => {
            const {data} = await Get({
                path: `${API_CONSTANTS.USERS.base}?${appendQueryParams({params})}`,
                token,
                toastError: true
            })
            return data
        },
        keepPreviousData: true
    })
}

export const useUsersFacet = () => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["usersFacet"],
        queryFn: async () => {
            const { data } = await Get({
                path: API_CONSTANTS.USERS.getFacet,
                token,
                toastError: true,
            })
            return data
        },
    })
}

export const useUserOptions = (params) => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["userOptions", params],
        queryFn: async () => {
            const { data } = await Get({
                path: `${API_CONSTANTS.USERS.getOptions}?${appendQueryParams({params})}`,
                token,
                toastError: true,
            })
            return data
        },
        staleTime: MILISECONDS.MAX
    })
}

export const useCreateUser = () => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (body) => {
            body = prepareData(body, API_CONSTANTS.USERS.dataKeys)
            const { data } = await Post({
                path: API_CONSTANTS.USERS.base,
                token,
                body,
                toastError: true,
                toastMessage:true
            })
            return data
        },
    })
}

export const useUpdateUser = (id) => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (body) => {
            body = prepareData(body, API_CONSTANTS.USERS.dataKeys)
            const { data } = await Put({
                path: `${API_CONSTANTS.USERS.base}/${id}`,
                token,
                body,
                toastMessage:true,
                toastError: true
            })
            return data
        },
    })
}

export const useDeleteUser = () => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (id) => {
            const { data } = await Delete({
                path: `${API_CONSTANTS.USERS.base}/${id}`,
                token,
                toastError: true,
                toastMessage:true
            })
            return data
        },
    })
}